import React, { useState, useEffect } from 'react';
import Typography from '../typography/Typography';
import './tabs.scss';
import { ITabs } from '../../types/tabs';

const Tabs = ({
  tabs, onChange,
}: ITabs) => {
  const classBase = 'custom-tabs';
  const tabClass = 'custom-tab';
  const [isActive, setActive] = useState(tabs[0]?.tab);

  const handleClick = (tab:string) => {
    setActive(tab);
  };

  useEffect(() => onChange(isActive), [isActive]);

  const tabWidth = `${100 / tabs.length}%`;

  return (
    <div
      className={`
      ${classBase} 
      tabs-wrapper 
      d-flex 
      ${tabs.length === 1 ? 'justify-content-center' : 'justify-content-space-between'}`}
      data-testid={classBase}
    >
      {tabs.length && tabs.map((tab, i) => (
        <div
          data-testid={`${tabClass}_${tab.label}`}
          className={`
            ${tabClass} 
            tab 
            d-flex 
            flex-direction-column 
            justify-content-center 
            align-items-center
          `}
          style={{ width: tabWidth }}
          key={i}
          onClick={() => {
            handleClick(tab.tab);
          }}
        >
          <div>{tab.icon}</div>

          <Typography color={tab.active ? 'asphalt6' : 'grey4'} variant={tab.active ? 'subtitle2' : 'body2'}>
            {tab.label}
          </Typography>

          {isActive === tab.tab && (
            <div className={`active-tab ${tabs.length === 1 ? 'full-width' : ''}`} style={{ width: tabWidth }} />
          )}
        </div>
      ))}
    </div>
  );
};

export default Tabs;
